import { render } from "./CircularBoard.vue?vue&type=template&id=7856ae68&scoped=true"
import script from "./CircularBoard.vue?vue&type=script&lang=js"
export * from "./CircularBoard.vue?vue&type=script&lang=js"

import "./CircularBoard.vue?vue&type=style&index=0&id=7856ae68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7856ae68"]])

export default __exports__